var _use, _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMondaycom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 68.208 42.208",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 1.604,
    y: 1.604
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.793 38.342c-2.836-.005-5.446-1.547-6.818-4.028s-1.291-5.512.213-7.916L15.23 3.94C16.71 1.577 19.338.183 22.124.283s5.307 1.679 6.614 4.142 1.2 5.436-.28 7.799L14.412 34.681c-1.427 2.28-3.929 3.664-6.619 3.661z",
    fill: "#ff3d57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.993 38.342c-2.838 0-5.452-1.54-6.828-4.022s-1.295-5.516.209-7.922L39.427 3.939c1.419-2.49 4.089-4.002 6.955-3.937s5.465 1.695 6.77 4.246 1.107 5.613-.517 7.975L38.609 34.681c-1.427 2.28-3.929 3.664-6.619 3.661z",
    fill: "#ffcb00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.371 30.719c0-4.221 3.486-7.62 7.815-7.62s7.815 3.398 7.815 7.62-3.486 7.62-7.815 7.62-7.815-3.398-7.815-7.62z",
    fill: "#00d647"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMondaycom);
export default __webpack_public_path__ + "static/media/mondaycom.f03b7eafb05f9ea31ecc09179b4b3f11.svg";
export { ForwardRef as ReactComponent };